import Box from '@mui/material/Box';
import { IconExclamationCircle, IconCircleCheck, IconHourglass } from '@tabler/icons-react';
import { DEFAULT_FORMAT } from '../../utils/dateUtil';
import { Typography, LinearProgress, Chip } from '@mui/material';
import { AppConfig } from 'AppConfig';
import moment from 'moment';

/*
    Temp solution: Add a 3-day buffer to scheduledRereshDate as the estimated refresh date. 
    estimated_completion_date is expected to be added to the apollo.refresh_report table in the future, and this logic need to be updated accordingly.
*/
const getEstimatedRefreshDate = (scheduledRefreshDate) =>
  moment(scheduledRefreshDate).add(3, 'days');

const getRefreshStatusConfig = (refreshStatus) => {
  if (['Very Late', 'Late'].includes(refreshStatus)) {
    return {
      icon: <IconExclamationCircle style={{ width: '1rem', height: '1rem', color: '#FFF' }} />,
      backgroundColor: '#D82727',
      label: 'Late',
      color: '#FFF',
      borderColor: '#D82727'
    }
  } 
  if (['Queued', 'Running'].includes(refreshStatus)) {
     return {
      icon: <IconHourglass style={{ width: '1rem', height: '1rem', color: '#000' }} />,
      backgroundColor: '#FFF',
      borderColor: '#71767A',
      label: 'Processing',
      color: '#000'
    }
  } 
  return {   
    icon: <IconCircleCheck style={{ width: '1rem', height: '1rem', color: '#FFF' }} />,
    backgroundColor: '#007A14',
    label: 'Current',
    color: '#FFF',
    borderColor: '#007A14'
  }
}

export default function RefreshDashboardColumns() {
  return [
    {
      field: 'tenantName',
      title: 'Tenant Name',
      customFilterAndSearch: (term, rowData) => rowData.tenantName.toLowerCase().includes(term.toLowerCase()),
      render: (rowData) => <span>{rowData.tenantName}</span>,
      filtering: false
    },
    {
      field: 'dataThruDate',
      title: 'Data Through Date',
      render: (rowData) => DEFAULT_FORMAT(rowData.dataThruDate),
      customSort: (a, b) => a.dataThruDate - b.dataThruDate,
      filtering: false,
      searchable: false
    },
    {
      field: 'scheduledRefreshDate',
      title: 'Estimated Refresh Date',
      render: (rowData) => DEFAULT_FORMAT(getEstimatedRefreshDate(rowData.scheduledRefreshDate)),
      customSort: (a, b) => a.scheduledRefreshDate - b.scheduledRefreshDate,
      filtering: false,
      searchable: false
    },
    {
      field: 'refreshProgress',
      title: 'Received Files',
      customSort: (a, b) => parseFloat(a.stagedFiles / a.totalFiles) - parseFloat(b.stagedFiles / b.totalFiles),
      render: (rowData) => {
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <Typography
             sx={{
                color: '#000',
                fontFamily: 'Noto Sans',
                fontStyle: 'normal',
                fontSize: '0.875rem',
                fontWeight: '400',
                lineHeight: '1.3125rem'
              }}
            >
              {rowData.stagedFiles + '/' + rowData.totalFiles}
            </Typography>
            <Box sx={{ width: '6.75rem'}}>
              <LinearProgress
                variant="determinate"
                value={(rowData.stagedFiles / rowData.totalFiles) * 100}
                sx={{
                  flex: 1,
                  height: '0.5rem',
                  borderRadius: '6.25rem',
                  backgroundColor: '#D5D5D5',
                  '& .MuiLinearProgress-bar': {
                    backgroundColor: '#068DF1'
                  }
                }}
              />
            </Box>
          </Box>
        );
      },
      filtering: false,
      searchable: false
    },
    {
      field: 'refreshStatus',
      title: 'Refresh Status',
      render: ({ refreshStatus }) => {

        const { icon, backgroundColor, label, color, borderColor } = getRefreshStatusConfig(refreshStatus);

        return (
          <Chip 
            icon={icon}
            label={label}
            sx={{
              height: '2rem',
              borderRadius: '1.5rem',
              background: `${backgroundColor} !important`,
              border: `1px solid ${borderColor} !important`,
              padding: '0.5rem 0.75rem 0.5rem 0.5rem',
              '& .MuiChip-label': {
                color: color,
                fontFamily: 'Noto Sans',
                fontStyle: 'normal',
                fontSize: '0.75rem',
                fontWeight: '400',
                lineHeight: '1.05rem'
              },
              '&:hover': {
                background: `${backgroundColor} !important`,
                border: `1px solid ${borderColor} !important`,
                opacity: '1 !important'
              },
              '& .MuiChip-icon': {
                color: color
              },
            }}
            disableRipple
          />
        );
      },
      filtering: false,
      searchable: false,
      customSort: (a, b) => {
        return AppConfig.REFRESH_STATUS_ORDER.indexOf(a.refreshStatus) - AppConfig.REFRESH_STATUS_ORDER.indexOf(b.refreshStatus);
      }
    }
  ];
}
